import axios from 'axios';
import { paymentService } from '@/app/pharmacy/shared/services/payment-service';
import { dispensedHistoryCommon } from '@/app/pharmacy/pharmacy-management/dispensed-history/dispensed-history-common';
import { visitService } from '../services/visit-service';

const state = {

    //start section of insurance component 
    formDataInsurance: {
        Contractor: [
            { text: 'Contractor-1', value: '1' },
            { text: 'Contractor-2', value: '2' },
            { text: 'Contractor-3', value: '3' },
            { text: 'Contractor-4', value: '4' },
            { text: 'Contractor-5', value: '5' },
            { text: 'Contractor-6', value: '6' },
            { text: 'Contractor-7', value: '7' }
        ],
        ContractorClient: [
            { text: 'ContractorClient-1', value: '1' },
            { text: 'ContractorClient-2', value: '2' },
            { text: 'ContractorClient-3', value: '3' },
            { text: 'ContractorClient-4', value: '4' },
            { text: 'ContractorClient-5', value: '5' },
            { text: 'ContractorClient-6', value: '6' },
            { text: 'ContractorClient-7', value: '7' }
        ],
        beneficiaryType: [
            { text: 'beneficiary Type-1', value: '1' },
            { text: 'beneficiary Type-2', value: '2' },
            { text: 'beneficiary Type-3', value: '3' },
            { text: 'beneficiary Type-4', value: '4' },
            { text: 'beneficiary Type-5', value: '5' },
            { text: 'beneficiary Type-6', value: '6' },
            { text: 'beneficiary Type-7', value: '7' }
        ],
        Contract: [
            { text: 'Contract-1', value: '1' },
            { text: 'Contract-2', value: '2' },
            { text: 'Contract-3', value: '3' },
            { text: 'Contract-4', value: '4' },
            { text: 'Contract-5', value: '5' },
            { text: 'Contract-6', value: '6' },
            { text: 'Contract-7', value: '7' }
        ],
        contractorCategory: [
            { text: 'contractor Category-1', value: '1' },
            { text: 'contractor Category-2', value: '2' },
            { text: 'contractor Category-3', value: '3' },
            { text: 'contractor Category-4', value: '4' },
            { text: 'contractor Category-5', value: '5' },
            { text: 'contractor Category-6', value: '6' },
            { text: 'contractor Category-7', value: '7' }
        ]
    },
    dataSourceInsurance: [
        {
            CardNumber: "1234-1234-1234-1234",
            expirtyDate: "20/12/2020",
            details: "this more details about credit card this more details about credit card this more details about credit card"
        },
        {
            CardNumber: "1234-1234-1234-1234",
            expirtyDate: "20/12/2020",
            details: "this more details about credit card"
        },
        {
            CardNumber: "1234-1234-1234-1234",
            expirtyDate: "20/12/2020",
            details: "this more details about credit card this more details about credit card this more details about credit card"
        },
        {
            CardNumber: "1234-1234-1234-1234",
            expirtyDate: "20/12/2020",
            details: "this more details about credit card"
        },
        {
            CardNumber: "1234-1234-1234-1234",
            expirtyDate: "20/12/2020",
            details: "this more details about credit card this more details about credit card this more details about credit card"
        }
    ],
    //End section of insurance component

    //start section of add payment component 
    paymentValues: {
        totalPaid: 11898,
        amountDue: 1125,
        wallet: 1189
    },
    formDataInsuranceAddPayment: {
        addamountPaid:
            [
                "item1",
                "item2",
                "item3",
                "item4",
                "item5",
                "item6",
                "item7",
            ],
        CashPoint:
            [
                "item1",
                "item2",
                "item3",
                "item4",
                "item5",
                "item6",
                "item7",
            ],
        Bank:
            [
                "item1",
                "item2",
                "item3",
                "item4",
                "item5",
                "item6",
                "item7",
            ],
        employee:
            [
                "item1",
                "item2",
                "item3",
                "item4",
                "item5",
                "item6",
                "item7",
            ],
    },
    dataSourcePayment: {},
    addPaymentInitParameters: { EmployeeEntityID: null, PaymentMethod: [] },
    isAddPaymentFirstLoad: false,
   // isChargePopup: false,
    sharedPaymentComponentInitData: {
        DataSources: {}
    },
    isLoadingAddItem: false,
    //End section of add payment component

    addedItemsDataSource: { data: [] },
    createVisitByPharmacistModel: {
        PatientID: null,
        PatientArName: null,
        PatientEnName: null,
        PatientCode: null,
        GenderID: null,
        GenderEnName: null,
        GenderArName: null,
        PatientPhone: null,
        NationalityID: null,
        IsDummyPatient: null,
        VisitClassificationID: null,
        VisitTypeID: null,
        VisitSourceID: null,
        FinancialStatusID: 1,
        CreatedFromVisitID: null,
        CreateVisitByOrder: null,
        ModifiedTS: null,

        VisitFinancialInfoModel: {
            ContractorID: null,
            ContractorArName: "",
            ContractorEnName: "",
            ContractorName: "",
            ContractID: null,
            ContractArName: "",
            ContractEnName: "",
            ContractName: "",
            BeneficiaryTypeID: null,
            BeneficiaryTypeArName: "",
            BeneficiaryTypeEnName: "",
            BeneficiaryTypeName: "",
            ContractCategoryID: null,
            ContractCategoryArName: "",
            ContractCategoryEnName: "",
            ContractCategoryName: "",
            ContractorClientID: null,
            ContractorClientArName: "",
            ContractorClientEnName: "",
            ContractorClientName: "",
            ContractorClientPolicyNumber: null,
            ContractorCode: null,
            ContractorCategoryCode: null,
            BeneficiaryTypeCode: null,
            ContractCode: null,
            CardId: null,
            CardExpiryDate: null,
            CardNo: null,
            IsExpired: null,
            IsSelected: null,
        },

        VisitPhyisicanOrders: [],
        VisitServiceModel: [],
        VisitAppointmentObj: {},
    },
    shouldEnableNextStep: false,
    isPatientCaptured: false,
    prescrptionWlakinLoader: false,
    createVisitWithDummyPatient: false,
    visitSourceDataSource: [],
    completedStepData: {},
    patientBannerRef: {},
    printDoseModel: {},
    printDoseInitModel: {}
};

// Get data
const getters = {
    getisLoadingAddItem(state) {
        return state.isLoadingAddItem
    },

    getPrintDoseInitModel(state) {
        return state.printDoseInitModel
    },
    getPrintDoseModel(state) {
        return state.printDoseModel
    },
    getPatientBannerRef(state) {
        return state.patientBannerRef
    },
    //start section of insurance component
    formDataInsurance(state) {
        return state.formDataInsurance;
    },
    completedStepData(state) {
        return state.completedStepData;
    },
    dataSourceInsurance(state) {
        return state.dataSourceInsurance;
    },
    //END section of insurance component 

    //start section of add payment component 
    dataSourcePayment(state) {
         
        return state.dataSourcePayment;
    },
    formDataInsuranceAddPayment(state) {
        return state.formDataInsuranceAddPayment;
    },
    paymentValues(state) {
        return state.paymentValues;
    },
    addPaymentInitParameters(state) {
        return state.addPaymentInitParameters;

    },
    isAddPaymentFirstLoad(state) {
        return state.isAddPaymentFirstLoad;

    },
    //isChargePopup(state) {
    //    return state.isChargePopup;

    //},
    sharedPaymentComponentInitData(state) {
        return state.sharedPaymentComponentInitData;

    },

    //End section of add payment component

    //Start Section: Add Items
    addedItemsDataSource(state) {
        return state.addedItemsDataSource;
    },

    //End Section Add Items

    //Start Section: Walkin Prescription
    shouldEnableNextStep(state) {
        return state.shouldEnableNextStep;
    },
    createVisitByPharmacistModel(state) {
        return state.createVisitByPharmacistModel;
    },

    isPatientCaptured(state) {
        return state.isPatientCaptured;
    },
    prescrptionWlakinLoader(state) {
        return state.prescrptionWlakinLoader
    },
    createVisitWithDummyPatient(state) {
        return state.createVisitWithDummyPatient;
    },
    visitSourceDataSource(state) {
        return state.visitSourceDataSource;
    }

    //End Section Walkin Prescription


};


// Update Data "mutations"
const mutations = {
    setIsLoadingAddItem(state, payload) {
        state.prescrptionWlakinLoader = payload
        state.isLoadingAddItem = payload
    },
    setPrintDoseModel(state, payload) {
        state.printDoseModel = payload
    },
    setPatientBannerRef(state, payload) {
        state.patientBannerRef = payload
    },
    edit_addedItemsDataSource(state, payload) {

        let index = state.addedItemsDataSource.data.indexOf(payload)
        state.addedItemsDataSource[index] = payload
    },
    commitGridItemChanges(state, payload) {
        let ds = [];
        let x = state.addedItemsDataSource.data.forEach(y => ds.push(y));
        console.log("typeof", x);

        state.addedItemsDataSource.data = ds;
        let index = state.addedItemsDataSource.data.findIndex(i => i.UniqueId == payload.UniqueId);
        state.addedItemsDataSource.data[index] = payload;
    },
    save_addedItemsDataSource(state, payload) {
        state.addedItemsDataSource = payload;
    },    
    save_visitSourceDataSource(state, payload) {
        state.visitSourceDataSource = payload;
    },

    //start section of insurance component
    save_formDataInsurance(state, formDataInsurance) {
        state.formDataInsurance = formDataInsurance;
    },
    save_dataSourceInsurance(state, dataSourceInsurance) {
        state.dataSourceInsurance = dataSourceInsurance;
    },
    //END section of insurance component

    //start section of add payment component 
    save_dataSourcePayment(state, dataSourcePayment) {
        state.dataSourcePayment = dataSourcePayment;
    },
    save_formDataInsuranceAddPayment(state, formDataInsuranceAddPayment) {
        state.formDataInsuranceAddPayment = formDataInsuranceAddPayment;
    },
    save_paymentValues(state, paymentValues) {
        state.dataSourcePayment = paymentValues;
    },
    Save_addPaymentInitParameters(state, payload) {
        state.addPaymentInitParameters = payload;
    },
    Save_isAddPaymentFirstLoad(state, payload) {
        state.prescrptionWlakinLoader = payload
        state.isAddPaymentFirstLoad = payload;
    },
    //Save_isChargePopup(state, payload) {
    //    state.isChargePopup = payload;
    //},
    Save_sharedPaymentComponentInitData(state, payload) {
        state.sharedPaymentComponentInitData = payload;
    },

    //End section of add payment component

    Save_shouldEnableNextStep(state, payload) {
        state.shouldEnableNextStep = payload;
    },

    Save_createVisitPatientObj(state, payload) {
        state.createVisitByPharmacistModel.PatientID = payload.PatientID;
        state.createVisitByPharmacistModel.PatientArName = payload.PatientArName;
        state.createVisitByPharmacistModel.PatientEnName = payload.PatientEnName;
        state.createVisitByPharmacistModel.PatientCode = payload.PatientCode;
        state.createVisitByPharmacistModel.GenderID = payload.GenderID;
        state.createVisitByPharmacistModel.GenderEnName = payload.GenderEnName;
        state.createVisitByPharmacistModel.GenderArName = payload.GenderArName;
        state.createVisitByPharmacistModel.PatientPhone = payload.PatientPhone;
        state.createVisitByPharmacistModel.NationalityID = payload.NationalityID;
        state.createVisitByPharmacistModel.IsDummyPatient = payload.IsDummyPatient;
    },

    Save_createVisitFinancialStatus(state, payload) {
        state.createVisitByPharmacistModel.FinancialStatusID = payload;
    },

    Save_createVisitFinancialInfo(state, payload) {
        state.createVisitByPharmacistModel.VisitFinancialInfoModel = payload;
    },

    Save_createVisitClassification(state, payload) {
        state.createVisitByPharmacistModel.VisitClassificationID = payload;
    },
    Save_createVisitType(state, payload) {
        state.createVisitByPharmacistModel.VisitTypeID = payload;
    },
    Save_createVisitServices(state, payload) {
        state.createVisitByPharmacistModel.VisitServiceModel = payload;
    },
    Save_createVisitCurrentVisitData(state, payload) {
        state.createVisitByPharmacistModel.CreatedFromVisitID = payload.visitId;
        state.createVisitByPharmacistModel.ModifiedTS = payload.modifiedTS;
        state.createVisitByPharmacistModel.CreateVisitByOrder = payload.createVisitByOrder;
    },
    Save_createVisitSource(state, payload) {
        state.createVisitByPharmacistModel.VisitSourceID = payload;
    },

    Save_createVisitPhysicianOrders(state, payload) {
        state.createVisitByPharmacistModel.VisitPhyisicanOrders = payload;
    },

    Save_isPatientCaptured(state, payload) {
        state.isPatientCaptured = payload;
    },

    Save_prescrptionWlakinLoader(state, payload) {
        state.prescrptionWlakinLoader = payload
    },
    Save_createVisitWithDummyPatient(state, payload) {
        state.createVisitWithDummyPatient = payload;
    },
    Save_completedStepData(state, payload) {
        state.completedStepData = payload;
    },
    init_serviceDoseModel(state, payload) {
        state.printDoseInitModel = payload
    },
    save_doseItems(state, payload) {
        state.printDoseInitModel.DoseList = payload
    }

};

const actions =
{
    set_isLoadingAddItem({ commit }, payload) {
        commit("setIsLoadingAddItem", payload);
    },
    save_doseList({ commit }, payload) {
        commit("save_doseItems", payload);
    },

    async init_serviceDose({ commit }, payload) {

        commit("setPrintDoseModel", payload);

        let VisitServiceIds = payload.SelectedIds.filter(item => item.IsOwnMedication == false).map(item => item.VisitServiceID);
        let OwnMedicationTransactionsIds = payload.SelectedIds.filter(item => item.IsOwnMedication == true).map(item => item.OwnMedicationTransactionID);

        await visitService.InitServiceDose(VisitServiceIds, OwnMedicationTransactionsIds, (response) => {
            console.log(response)
            let printDoseInitModel = {};
            if (response.data) {
                printDoseInitModel.DoseFrequencyDS = response.data.LKP_DosageFrequencies;
                printDoseInitModel.RepeatUnitDS = response.data.DosageRepeatUnits;

                payload.dosePopUPRef.map_DoseModel(response.data.VisitServiceDoseDetails).then((doseList) => {
                    printDoseInitModel.DoseList = doseList
                    commit("init_serviceDoseModel", printDoseInitModel);
                    payload.dosePopUPRef.setDoseDataSource(printDoseInitModel.DoseList);
                   
                });
            }

        });
    },
    save_patientBannerRef({ commit }, payload) {
        commit("setPatientBannerRef", payload);
    },
    load_shouldEnableNextStep({ commit }, payload) {
        commit("Save_shouldEnableNextStep", payload);
    },
    Save_createVisitWithDummyPatient({ commit }, payload) {
        commit("Save_createVisitWithDummyPatient", payload);
    },
    Save_completedStepData({ commit }, payload) {
        commit("Save_completedStepData", payload);
    },
    Save_createVisitPatientObj({ commit }, payload) {
        commit("Save_createVisitPatientObj", payload);
    },
    Save_createVisitFinancialInfo({ commit }, payload) {
        commit("Save_createVisitFinancialInfo", payload);
    },
    Save_createVisitPhysicianOrders({ commit }, payload) {
        commit("Save_createVisitPhysicianOrders", payload);
    },
    Save_isPatientCaptured({ commit }, payload) {
        commit("Save_isPatientCaptured", payload);
    },
    Save_prescrptionWlakinLoader({ commit }, payload) {
        commit("Save_prescrptionWlakinLoader", payload)
    },
    Save_createVisitClassification({ commit }, payload) {
        commit("Save_createVisitClassification", payload);
    },
    Save_createVisitType({ commit }, payload) {
        commit("Save_createVisitType", payload);
    },
    Save_createVisitServices({ commit }, payload) {
        commit("Save_createVisitServices", payload);
    },
    Save_createVisitCurrentVisitData({ commit }, payload) {
        commit("Save_createVisitCurrentVisitData", payload);
    },
    Save_createVisitSource({ commit }, payload) {
        commit("Save_createVisitSource", payload);
    },

    Save_createVisitFinancialStatus({ commit }, payload) {
        commit("Save_createVisitFinancialStatus", payload);
    },
    save_visitSourceDataSource({ commit }, payload) {
        commit("save_visitSourceDataSource", payload);
    },
    load_addedItemsDataSource({ commit }, payload) {
        commit("save_addedItemsDataSource", payload);
        commit("setIsLoadingAddItem", false);
    },
    edit_addedItemsDataSource({ commit }, payload) {
        commit("edit_addedItemsDataSource", payload);
    },
    FilpHasOwnMedicationFlag({ commit }, payload) {        
        commit('edit_addedItemsDataSource', payload)
    },
    //start section of insurance component
    load_formDataInsurance(context) {
        //dummy url for load data 
        //https://jsonplaceholder.typicode.com/users
        axios.get('https://jsonplaceholder.typicode.com/users')
            .then((result) => {
                context.commit('save_formDataInsurance', result.data);
            });
    },
    load_dataSourceInsurance(context) {
        //dummy url for load data 
        //https://jsonplaceholder.typicode.com/users
        axios.get('')
            .then((result) => {
                context.commit('save_dataSourceInsurance', result.data);
            });
    },
    //END section of insurance component

    //start section of add payment component 
    //load_dataSourcePayment(context) {
    //    //dummy url for load data 
    //    //https://jsonplaceholder.typicode.com/users
    //    axios.get('')
    //        .then((result) => {
    //            context.commit('save_dataSourcePayment', result.data);
    //        });
    //},
    load_dataSourcePayment({ commit }, payload) {
        commit('save_dataSourcePayment', payload);

    },
    load_formDataInsuranceAddPayment(context) {
        //dummy url for load data 
        //https://jsonplaceholder.typicode.com/users
        axios.get('')
            .then((result) => {
                context.commit('save_formDataInsuranceAddPayment', result.data);
            });
    },
    load_paymentValues(context) {
        //dummy url for load data 
        //https://jsonplaceholder.typicode.com/users
        axios.get('')
            .then((result) => {
                context.commit('save_paymentValues', result.data);
            });
    },

    Save_sharedPaymentComponentInitData({ commit }, payload) {
        commit('Save_sharedPaymentComponentInitData', payload);
    },


    async Save_addPaymentInitParameters({ commit }, payload) {
        commit('Save_isAddPaymentFirstLoad', false)
        let addPaymentInitObj = payload;

        await paymentService.InitPharmacyPaymentPopup(addPaymentInitObj.EntitiesList, (response) => {
            if (response.data) {

                addPaymentInitObj.CashPointDataSource = {
                    data: response.data.CashPoint,
                    sort: {
                        field: "Name",
                        dir: "asc"
                    }
                };

                addPaymentInitObj.BankDataSource = {
                    data: response.data.Bank,
                    sort: {
                        field: "Name",
                        dir: "asc"
                    }
                };

                addPaymentInitObj.PaymentMethod = dispensedHistoryCommon.SetPaymentMethodsPermissions(response.data.PaymentMethod);
                addPaymentInitObj.OrganizationUnits = response.data.Organization;
                addPaymentInitObj.EmployeeEntityID = response.data.EmployeeEntityID;

                commit('Save_addPaymentInitParameters', addPaymentInitObj);
                commit('Save_isAddPaymentFirstLoad', true);

            }
        }
        );

    },

    Save_isAddPaymentFirstLoad(context, payload) {
        context.commit('Save_isAddPaymentFirstLoad', payload);

    }
    //End section of add payment component
};

export default {
    mutations,
    actions,
    state,
    getters
};
